





































import { Component, Prop } from 'vue-property-decorator';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormError from '@/components/common/forms/FormError.vue';
import { GoalValueModel, GoalValueType } from 'admiral-core';
import FormTextarea from '@/components/common/forms/FormTextarea.vue';
import { CheckIcon, CopyIcon, PlusIcon } from 'vue-feather-icons';
import FormDateInput from '@/components/common/forms/FormDateInput.vue';
import AgencyStatusSelect from '@/components/common/selects/AgencyStatusSelect.vue';
import AdmiralCheckbox from '@/components/common/selects/AdmiralCheckbox.vue';
import ProductSelect from '@/components/common/selects/ProductSelect.vue';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';

@Component({
  components: {
    UserSelect,
    ProductSelect,
    AdmiralCheckbox,
    AgencyStatusSelect,
    FormDateInput,
    FormTextarea,
    FormError,
    FormInput,
    FormRow,
    PlusIcon,
    CopyIcon,
    CheckIcon,
  },
})
export default class GoalValueForm extends mixins(BaseMixin) {
  @Prop({ required: true, type: Object })
  readonly value!: GoalValueModel;

  @Prop({ required: true, type: Object })
  readonly errors!: GoalValueModel;

  onInput(key: string, value: any) {
    this.$emit('input', { ...this.value, [key]: value });
  }

  onErrorReset(key: string) {
    this.$emit('reset-error', key);
  }

  get isValueType() {
    return this.value.valueType === GoalValueType.Valuation;
  }

  get isQuantityType() {
    return this.value.valueType === GoalValueType.Quantity;
  }
  updateValueType(valueType: GoalValueType) {
    this.onInput('valueType', valueType);
  }

  updateAudience(audience: 'agency' | 'user') {
    if (audience === 'agency') {
      this.onInput('agency', this.agency);
    } else {
      this.onInput('agency', undefined);
    }
  }
}
